


































import { Component, Prop, Vue } from "@/shared/vuepack";
import { useDebitCardManagementStore } from "@/shared/store/debitCardManagement";
import { CardStatus, DebitCardRecord } from "@/shared/types";
import AccountHolderWidgetBase from "@/employer/components/partner-ee-service/v2/AccountHolderWidgetBase.vue";
import Pill from "@/shared/components/ui/Pill.vue";

interface DebitCardTableItem {
  name: string;
  primaryOrSecondary: string;
  cardNumberLast4: string;
  statusIndicator: string;
  statusText: string;
}

const cardStatusDisplayMap: Record<CardStatus, string> = {
  none: "None",
  active: "Active",
  lostOrDamaged: "Lost or Damaged",
  closed: "Closed",
  replacementRequested: "Replacement Requested",
  pending: "Pending",
  error: "Error",
  embossing: "Embossing",
  fraudOrStolen: "Fraud or Stolen",
  fraud: "Fraud",
  stolen: "Stolen",
  suspended: "Suspended"
};

@Component({
  components: {
    AccountHolderWidgetBase,
    Pill
  }
})
export default class AccountHolderDebitCards extends Vue {
  debitCardsStore = useDebitCardManagementStore();

  @Prop({ required: true })
  username: string;

  @Prop({ required: true })
  partnerId: number;

  get cards (): DebitCardTableItem[] {
    return this.debitCardsStore.debitCards.map(card => ({
      name: this.getName(card),
      primaryOrSecondary: card.isPrimary ? "Primary" : "Secondary",
      cardNumberLast4: card.cardNumberLast4,
      statusIndicator: this.getStatusIndicator(card),
      statusText: cardStatusDisplayMap[card.cardStatus]
    }));
  }

  get isLoading () {
    return this.debitCardsStore.debitCardsLoading;
  }

  get isLoaded () {
    return this.debitCardsStore.debitCardsLoaded;
  }

  get isFailed () {
    return this.debitCardsStore.debitCardsFailed;
  }

  get hasData () {
    return this.isLoaded && this.cards && this.cards.length > 0;
  }

  loadData () {
    this.debitCardsStore.resetDebitCards();
    this.debitCardsStore.getDebitCards({ username: this.username, partnerId: this.partnerId });
  }

  getName (card: DebitCardRecord) {
    if (card.lastName) {
      return `${card.firstName} ${card.lastName}`;
    }

    return card.firstName;
  }

  getStatusIndicator (card: DebitCardRecord) {
    switch (card.cardStatus) {
      case CardStatus.None:
        return "neutral-pill";
      case CardStatus.Active:
        return "green-bg";
      case CardStatus.LostOrDamaged:
        return "warning-pill";
      case CardStatus.Closed:
        return "warning-pill";
      case CardStatus.ReplacementRequested:
        return "neutral-pill";
      case CardStatus.Pending:
        return "neutral-pill";
      case CardStatus.Error:
        return "red-bg";
      case CardStatus.Embossing:
        return "neutral-pill";
      case CardStatus.Fraud:
        return "warning-pill";
      case CardStatus.Stolen:
        return "warning-pill";
      default:
        return "neutral-pill";
    }
  }
}
